import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Modal, Select, Typography } from 'antd';

const { Text } = Typography;

/**
 * Abre e retorna:
 *   { id, nome }
 * ou null (cancelado)
 *
 * Ex:
 * const escolha = await modalRef.current.abrir({
 *   titulo: 'Selecione o item',
 *   descricao: 'EAN ...',
 *   itens: [{id:'1', nome:'Produto X'}, {id:'2', nome:'Embalagem Y'}]
 * })
 */
const ModalEscolhaItemAsync = forwardRef((_, ref) => {
  const resolverRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [titulo, setTitulo] = useState('Selecione');
  const [descricao, setDescricao] = useState('');
  const [itens, setItens] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const abrir = ({ titulo, descricao, itens }) => {
    const arr = Array.isArray(itens) ? itens : [];

    setTitulo(titulo || 'Selecione');
    setDescricao(descricao || '');
    setItens(arr);
    setSelectedId(arr[0]?.id ?? null);
    setOpen(true);

    return new Promise((resolve) => {
      resolverRef.current = resolve;
    });
  };

  const confirmar = () => {
    const resolve = resolverRef.current;
    resolverRef.current = null;
    setOpen(false);

    const escolhido = itens.find((x) => String(x.id) === String(selectedId));
    resolve?.(escolhido ? { id: escolhido.id, nome: escolhido.nome } : null);
  };

  const cancelar = () => {
    const resolve = resolverRef.current;
    resolverRef.current = null;
    setOpen(false);
    resolve?.(null);
  };

  useImperativeHandle(ref, () => ({ abrir }));

  return (
    <Modal
      open={open}
      title={titulo}
      onCancel={cancelar}
      destroyOnClose
      footer={[
        <button
          key="cancelar"
          onClick={cancelar}
          style={{
            padding: '6px 14px',
            borderRadius: 6,
            border: '1px solid #ccc',
            backgroundColor: '#fff',
            cursor: 'pointer',
          }}
        >
          Cancelar
        </button>,
        <button
          key="confirmar"
          onClick={confirmar}
          disabled={!selectedId}
          style={{
            padding: '6px 14px',
            borderRadius: 6,
            border: 'none',
            backgroundColor: '#1677ff',
            color: '#fff',
            cursor: selectedId ? 'pointer' : 'not-allowed',
            opacity: selectedId ? 1 : 0.6,
          }}
        >
          Confirmar
        </button>,
      ]}
    >
      {descricao ? (
        <Text
          type="secondary"
          style={{ display: 'block', marginBottom: 8, whiteSpace: 'pre-line' }}
        >
          {descricao}
        </Text>
      ) : null}
      <Select
        style={{ width: '100%' }}
        value={selectedId}
        onChange={setSelectedId}
        placeholder="Selecione"
        options={itens.map((x) => ({ label: x.nome, value: x.id }))}
        showSearch
        optionFilterProp="label"
      />
    </Modal>
  );
});

export default ModalEscolhaItemAsync;
